import axiosInstance from "@/shared/api/axiosInstance.js";

/**
 * filters = {
 *   systemFilters: string[],        // ["D&D 5E", "Cyberpunk RED"]
 *   gameFormatFilters: string[],    // ["ONLINE", "OFFLINE"]
 * }
 */

const appendMultiFilters = (params, filters = {}) => {
    const systemFilters = filters?.systemFilters ?? [];
    const gameFormatFilters = filters?.gameFormatFilters ?? [];

    systemFilters.forEach((s) => params.append("systemFilter", s));
    gameFormatFilters.forEach((f) => params.append("gameFormatFilter", f));
};

const buildCatalogParams = ({ search, page, size, filters }) => {
    const params = new URLSearchParams();

    params.set("search", search);
    params.set("page", String(page));
    params.set("size", String(size));

    appendMultiFilters(params, filters);

    return params;
};

// ✅ COUNT тоже с фильтрами (multi-value)
export const getCountCard = (filters = {}) => {
    const params = new URLSearchParams();
    appendMultiFilters(params, filters);

    // будет: /catalog-cards/count/formats?systemFilter=...&systemFilter=...&gameFormatFilter=...&gameFormatFilter=...
    return axiosInstance.get("/catalog-cards/count/formats", { params });
};

export const getOneShots = (page = 0, size = 6, filters = {}) => {
    const params = buildCatalogParams({
        search: "Ваншот",
        page,
        size,
        filters,
    });

    return axiosInstance.get("/catalog-cards", { params });
};

export const getCampaigns = (page = 0, size = 6, filters = {}) => {
    const params = buildCatalogParams({
        search: "Кампейн",
        page,
        size,
        filters,
    });

    return axiosInstance.get("/catalog-cards", { params });
};
